import { bindingMode } from 'aurelia-binding';
import { customElement } from 'aurelia-templating';
import { bindable } from 'aurelia-typed-observable-plugin';
import { CategoriesClient, CategoryViewModel } from '@dynamik/common/clients/transaction-clients';
import { CategoryType } from '../../classes/category-type';
import { CustomerService } from '@dynamik/common';
import { debounceTime, Subject, takeUntil } from '../../rxjs-local';

@customElement('portfolio-selector')
export class PortfolioSelector {
  constructor(private categoriesClient: CategoriesClient, private customerService: CustomerService) { }

  portfolios: CategoryViewModel[];
  destroy$ = new Subject<void>();

  @bindable
  label: string;

  @bindable({ defaultBindingMode: bindingMode.twoWay })
  value: string;

  attached() {
    this.customerService.selectedCustomer$
      .pipe(
        debounceTime(500),
        takeUntil(this.destroy$)
      )
      .subscribe(() => this.load());
  }

  async load() {
    this.portfolios = await this.categoriesClient.getSecCategories(this.customerService.selectedCustomer.companyId, CategoryType.Portfolio);
  }

  detached() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
